const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV

const API_BASE_URL_LIST = {
  "development":  "https://pzj5ji42gb.execute-api.ap-northeast-1.amazonaws.com/api",
  "staging":     "https://xexcoshs82.execute-api.ap-northeast-1.amazonaws.com/api",
  "production": "https://ny43l5e4pe.execute-api.ap-northeast-1.amazonaws.com/api"
}

const API_ID = "TOHOKU"
const SITE_TITLE = "TOHOKU MaaS"
const TOKEN_KEY = "myPlanToken"
const API_MIXWAY_PATH = "https://mixway.ekispert.jp/v1/json/"
const API_KEY = "j8bs7t3fS6ckVZ3h"
const AVAILABLE_LANGUAGES = ['ja', 'en', 'zh-TW']
const ENABLED_DOCOMO_MOBAKU = true

const JREAST_APP_SCHEMA = "https://jreastapp.page.link"
const JREAST_PC_SITE = "https://play.google.com/store/apps/details?id=jp.co.jreast&hl=ja"
const MIXWAY_URL = "https://mixway.ekispert.net"

// 中心となる駅
const DEFAULT_STATION_LOCATION = {
  latitude: 38.2601316,
  longitude: 140.8802488
}
const DEFAULT_STATION = "仙台"
const DEFAULT_DEPARTURE_STATION = "仙台"
const DEFAULT_ARRIVAL_STATION = "仙台"
const DEFAULT_DEPARTURE_STATION_CODE = "21044"
const DEFAULT_ARRIVAL_STATION_CODE = "21044"

const TOHOKU_MAAS_CALL_CENTER = "0120-012-705"

const LINK_BASE_URL_LIST = {
  "development": "https://dev.maas-portal.com",
  "staging": "https://stg.maas-portal.com",
  "production": "https://maas-portal.com"
}

// typeは出発地・到着地の指定方法
//  BUSSTOP: ピンを選択して指定
//  POSITION: 地図上で緯度経度を指定
const DOCOMO_API_BASE_URL_LIST = {
  "development":  "https://36tg49cdnh.execute-api.ap-northeast-1.amazonaws.com/",
  "staging":     "https://t7hgq7pcqc.execute-api.ap-northeast-1.amazonaws.com/",
  "production": "https://uiu624urck.execute-api.ap-northeast-1.amazonaws.com/"
}
const DOCOMO_API_URL = DOCOMO_API_BASE_URL_LIST[env_key]
const TERM_OF_TOHOKU = "termOfTohoku"
const DOCOMO_SERVICE_AREAS = [
  // 秋保
  {
    id: 1021,
    url: DOCOMO_API_BASE_URL_LIST[env_key],
    type: 'BUSSTOP',
    term: TERM_OF_TOHOKU,
    location: { // 秋保グランドホテル
      lat: 38.224025,
      lng: 140.730822
    }
  },
  // 弘前
  {
    id: 1039,
    url: DOCOMO_API_BASE_URL_LIST[env_key],
    type: 'BUSSTOP',
    term: TERM_OF_TOHOKU,
    location: { // 弘前駅
      lat: 40.5994708,
      lng: 140.4844918
    }
  },
  // 角館
  {
    id: 1040,
    url: DOCOMO_API_BASE_URL_LIST[env_key],
    type: 'BUSSTOP',
    term: TERM_OF_TOHOKU,
    location: { // ＪＲ東日本 角館駅
      lat: 39.591764,
      lng: 140.570816
    }
  },
  // 一関
  {
    id: 1043,
    url: DOCOMO_API_BASE_URL_LIST[env_key],
    type: 'BUSSTOP',
    term: TERM_OF_TOHOKU,
    location: { // 一ノ関駅
      lat: 38.9343767,
      lng: 141.1268678
    }
  },
  {
    id: 1047,
    url: DOCOMO_API_BASE_URL_LIST[env_key],
    type: 'BUSSTOP',
    term: TERM_OF_TOHOKU,
    location: { // 秋保グランドホテル
      lat: 38.224025,
      lng: 140.730822
    }
  }
]

const SENDAI_STA_POLE = [
  {
    no: "4",
    poi_id: "2104404"
  },
  {
    no: "5",
    poi_id: "2104405"
  },
  {
    no: "6",
    poi_id: "2104406"
  },
  {
    no: "9",
    poi_id: "2104409"
  },
  {
    no: "10",
    poi_id: "2104410"
  },
  {
    no: "11",
    poi_id: "2104411"
  },
  {
    no: "13",
    poi_id: "2104413"
  },
  {
    no: "14",
    poi_id: "2104414"
  },
  {
    no: "15",
    poi_id: "2104415"
  },
  {
    no: "16",
    poi_id: "2104416"
  },
  {
    no: "17",
    poi_id: "2104417"
  },
  {
    no: "18",
    poi_id: "2104418"
  },
  {
    no: "19",
    poi_id: "2104419"
  },
  {
    no: "27",
    poi_id: "2104427"
  },
  {
    no: "28",
    poi_id: "2104428"
  },
  {
    no: "50",
    poi_id: "2104450"
  },
  {
    no: "51",
    poi_id: "2104451"
  },
  {
    no: "60",
    poi_id: "2104460"
  },
  {
    no: "98",
    poi_id: "2104498"
  }
]

export default {
  API_ID: API_ID,
  SITE_TITLE: SITE_TITLE,
  TOKEN_KEY: TOKEN_KEY,
  API_MIXWAY_PATH: API_MIXWAY_PATH,
  API_KEY: API_KEY,
  AVAILABLE_LANGUAGES: AVAILABLE_LANGUAGES,
  ENABLED_DOCOMO_MOBAKU: ENABLED_DOCOMO_MOBAKU,
  DEFAULT_STATION_LOCATION: DEFAULT_STATION_LOCATION,
  DEFAULT_STATION: DEFAULT_STATION,
  DEFAULT_DEPARTURE_STATION: DEFAULT_DEPARTURE_STATION,
  DEFAULT_ARRIVAL_STATION: DEFAULT_ARRIVAL_STATION,
  DEFAULT_DEPARTURE_STATION_CODE: DEFAULT_DEPARTURE_STATION_CODE,
  DEFAULT_ARRIVAL_STATION_CODE: DEFAULT_ARRIVAL_STATION_CODE,
  JREAST_APP_SCHEMA: JREAST_APP_SCHEMA,
  JREAST_PC_SITE: JREAST_PC_SITE,
  MIXWAY_URL: MIXWAY_URL,
  LINK_BASE_URL_LIST: LINK_BASE_URL_LIST,
  API_BASE_URL_LIST: API_BASE_URL_LIST,
  DOCOMO_SERVICE_AREAS: DOCOMO_SERVICE_AREAS,
  DOCOMO_API_URL: DOCOMO_API_URL,
  SENDAI_STA_POLE: SENDAI_STA_POLE,
  TOHOKU_MAAS_CALL_CENTER: TOHOKU_MAAS_CALL_CENTER
}